/* eslint-disable @typescript-eslint/no-explicit-any */
import {
	AssignStatus,
	InclusionFilterStatus,
	PriorityFilterStatus,
	SelectType,
	SignalFilterStatus,
} from "@/enum/list.enum";

import type { ExecuteBulkDeepResearchListRequest } from "@/pages/Private/redux/deepResearch/deepResearch.api";

import type { IFilterWithValues } from "../../FilterModal";

export interface DeepResearchBulkListPayloadFilters {
	assignStatus?: AssignStatus[];
	filter?: Record<string, any>;
	inclusionFilterStatus?: InclusionFilterStatus[];
	/** The table's search: a select-all made while searching covers the matches only (PREC-4443). */
	searchValue?: string;
	/** Every status of the tab the table showed; the Assigned tab stands for several (PREC-4450). */
	assignStatuses?: AssignStatus[];
	/** The reason sub-filters the table showed, "STATUS:filterParam" (PREC-4450). */
	exclusionReasons?: string[];
	signalFilterStatus?: SignalFilterStatus[];
}

interface BuildDeepResearchBulkListPayloadParams {
	listId: number;
	listPersonIds: number[];
	selectType: SelectType;
	deepResearchPromptId: number;
	filters?: DeepResearchBulkListPayloadFilters;
	priorityFilterStatus?: PriorityFilterStatus[];
}

export const buildDeepResearchBulkListPayload = ({
	listId,
	listPersonIds,
	selectType,
	deepResearchPromptId,
	filters,
	priorityFilterStatus,
}: BuildDeepResearchBulkListPayloadParams): ExecuteBulkDeepResearchListRequest => ({
	...(listPersonIds.length > 0 ? { listPersonIds } : { listId }),
	selectType,
	deepResearchPromptId,
	...(selectType === SelectType.ALL && filters?.filter
		? { filter: filters.filter as IFilterWithValues }
		: {}),
	...(selectType === SelectType.ALL && filters?.inclusionFilterStatus
		? { inclusionFilterStatus: filters.inclusionFilterStatus }
		: {}),
	...(selectType === SelectType.ALL && priorityFilterStatus ? { priorityFilterStatus } : {}),
	...(selectType === SelectType.ALL && filters?.assignStatus?.length
		? { assignStatus: filters.assignStatus }
		: {}),
	...(selectType === SelectType.ALL && filters?.searchValue
		? { searchValue: filters.searchValue }
		: {}),
	...(selectType === SelectType.ALL && filters?.assignStatuses?.length
		? { assignStatuses: filters.assignStatuses }
		: {}),
	...(selectType === SelectType.ALL && filters?.exclusionReasons?.length
		? { exclusionReasons: filters.exclusionReasons }
		: {}),
	...(selectType === SelectType.ALL && filters?.signalFilterStatus?.length
		? { signalFilterStatus: filters.signalFilterStatus }
		: {}),
});
